module.exports = "https://static.wmbcdn.com/uniweb/images/afba4c31010d0c0f52edb1ae2a84ef56.svg";